import { userRequest } from '../lib/userRequest';

export const getAppConfig = async () => {
  return userRequest('get', '/config', {}, false, {}, true);
};